/**
 * Project: academy-v2
 * File: TrashBinIcon
 * Author: wanpeninsula
 * Author URI: https://www.pennycodes.dev
 * Created: 16/11/2023 at 7:03 am
 *
 * Copyright (c) 2023 academy-v2. All rights reserved.
 */
import React from "react";
const TrashBinIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={60}
    fill="none"
    {...props}
  >
    <path
      fill="#8065C9"
      d="M22.615 9.643v1.071h10.77V9.643c0-1.421-.568-2.784-1.577-3.788A5.399 5.399 0 0 0 28 4.285a5.399 5.399 0 0 0-3.808 1.57 5.343 5.343 0 0 0-1.577 3.788Zm-4.307 1.071V9.643a9.618 9.618 0 0 1 2.838-6.819A9.718 9.718 0 0 1 28 0a9.718 9.718 0 0 1 6.853 2.824 9.618 9.618 0 0 1 2.84 6.819v1.071h16.153a2.16 2.16 0 0 1 1.523.628 2.137 2.137 0 0 1 0 3.03 2.16 2.16 0 0 1-1.523.628h-3.248l-4.075 35.503a10.697 10.697 0 0 1-3.532 6.78A10.8 10.8 0 0 1 35.82 60H20.18a10.8 10.8 0 0 1-7.172-2.718 10.697 10.697 0 0 1-3.532-6.78L5.402 15H2.154a2.16 2.16 0 0 1-1.523-.628 2.137 2.137 0 0 1 0-3.03 2.16 2.16 0 0 1 1.523-.628h16.154Zm-4.55 39.3a6.418 6.418 0 0 0 2.118 4.068 6.48 6.48 0 0 0 4.301 1.632h15.644a6.48 6.48 0 0 0 4.301-1.632 6.418 6.418 0 0 0 2.117-4.068L46.265 15H9.738l4.02 35.014Zm7.78-27.514a2.16 2.16 0 0 1 1.523.628c.404.401.631.947.631 1.515V46.07c0 .569-.227 1.114-.63 1.516a2.16 2.16 0 0 1-3.047 0 2.137 2.137 0 0 1-.63-1.516V24.643c0-.569.226-1.114.63-1.515a2.16 2.16 0 0 1 1.523-.628Zm15.077 2.143c0-.569-.227-1.114-.63-1.515a2.16 2.16 0 0 0-3.047 0c-.403.401-.63.947-.63 1.515V46.07c0 .569.227 1.114.63 1.516a2.16 2.16 0 0 0 3.046 0c.404-.402.631-.947.631-1.516V24.643Z"
    />
  </svg>
);

export default TrashBinIcon;
